import type { CreativeBriefResponse } from '@innovationdepartment/proxima-sdk-axios';
import { useCallback, useState } from 'react';

import {
  AssetImage,
  AssetPreviewWrapper,
  OverlayIndicator,
  TopPanelArea
} from '../styles/briefPanel.styles';

type AssetPreviewProps = {
  assets: CreativeBriefResponse['assets'];
  title: string;
};

const AssetPreview = ({ assets, title }: AssetPreviewProps) => {
  const [showOverlay, setShowOverlay] = useState(false);

  const asset = assets[0];
  const hasOverlay = Boolean(asset?.overlayUrl && asset.overlayUrl !== asset.url);

  const handleMouseEnter = useCallback(() => {
    if (hasOverlay) setShowOverlay(true);
  }, [hasOverlay]);

  const handleMouseLeave = useCallback(() => {
    setShowOverlay(false);
  }, []);

  if (!asset) {
    return <TopPanelArea>No asset available</TopPanelArea>;
  }

  const currentSrc = showOverlay && hasOverlay ? asset.overlayUrl : asset.url;

  return (
    <AssetPreviewWrapper onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <AssetImage src={currentSrc} alt={title} />
      {!!hasOverlay && (
        <OverlayIndicator>{showOverlay ? 'With Text' : 'Without Text'}</OverlayIndicator>
      )}
    </AssetPreviewWrapper>
  );
};

export default AssetPreview;
